<div class="atividade-page ds-page">
  <header class="ds-page-header">
    <div class="ds-page-header-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M16 11l2 2 4-4"/>
      </svg>
    </div>
    <div class="ds-page-header-copy">
      <h1 class="ds-page-title">Atividade de Acessos</h1>
      <p class="ds-page-subtitle">Acompanhe usuários conectados e o último acesso registrado</p>
    </div>
    <div class="ds-page-actions">
      <button type="button" class="ds-btn ds-btn--no-icon" (click)="carregar()" [disabled]="carregando"><app-loading-indicator *ngIf="carregando" size="inline"></app-loading-indicator>
        {{ carregando ? 'Atualizando...' : 'Atualizar' }}
      </button>
    </div>
  </header>

  <main class="ds-page-content">
    <section class="resumo-grid">
      <article class="ds-card resumo-card">
        <span>Usuários online</span>
        <strong class="total-online">{{ totalOnline }}</strong>
      </article>
      <article class="ds-card resumo-card">
        <span>Usuários monitorados</span>
        <strong>{{ totalUsuarios }}</strong>
      </article>
      <article class="ds-card resumo-card resumo-atualizacao">
        <span>Última atualização</span>
        <strong>{{ formatarDataHora(atualizadoEm) }}</strong>
      </article>
    </section>

    <div *ngIf="erro" class="ds-alert ds-alert--danger">{{ erro }}</div>

    <section class="ds-card atividade-card">
      <div class="ds-card-header atividade-header">
        <div>
          <h2 class="ds-card-title">Atividade de usuários</h2>
          <p>Atualização automática a cada 30 segundos</p>
        </div>
        <input class="ds-input ds-input--sm" type="search" [(ngModel)]="filtro" (ngModelChange)="buscar()"
               placeholder="Buscar usuário" aria-label="Buscar usuário monitorado">
      </div>

      <div *ngIf="carregando" class="estado-carregando">
        <app-loading-indicator></app-loading-indicator>
        Atualizando atividade...
      </div>

      <div class="ds-table-container tabela-wrap" *ngIf="!carregando">
        <table class="ds-table ds-table--compact ds-table--sticky-header">
          <thead>
            <tr>
              <th>Status</th>
              <th>Usuário</th>
              <th>Último acesso</th>
              <th>Login</th>
              <th>Sessões abertas</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let usuario of usuariosPagina">
              <td>
                <span class="ds-badge" [class.ds-badge--success]="usuario.online"
                      [class.ds-badge--pending]="!usuario.online">
                  {{ usuario.online ? 'Online' : 'Inativo' }}
                </span>
              </td>
              <td><button type="button" class="usuario-link" (click)="selecionar(usuario)" [attr.aria-pressed]="selecionado?.usuario === usuario.usuario">{{ usuario.usuario }}</button></td>
              <td>{{ formatarDataHora(usuario.ultimoAcessoEm) }}</td>
              <td>{{ formatarDataHora(usuario.loginEm) }}</td>
              <td>{{ usuario.sessoesAbertas }}</td>
            </tr>
            <tr *ngIf="usuariosFiltrados().length === 0">
              <td class="ds-table-empty" colspan="5">Nenhum usuário encontrado.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <nav class="paginacao" aria-label="Paginação de usuários">
        <span>{{ usuariosFiltrados().length }} usuário(s) · 20 por página</span>
        <button type="button" class="ds-btn ds-btn--no-icon" (click)="pagina = pagina - 1" [disabled]="pagina <= 1">Anterior</button>
        <span aria-live="polite">Página {{ pagina }} de {{ totalPaginas }}</span>
        <button type="button" class="ds-btn ds-btn--no-icon" (click)="pagina = pagina + 1" [disabled]="pagina >= totalPaginas">Próxima</button>
      </nav>
      <p class="atividade-observacao" *ngIf="observacao">{{ observacao }}</p>
    </section>
    <section *ngIf="selecionado as usuario" class="ds-card detalhes-card" aria-label="Detalhes do usuário">
      <div class="ds-card-header">
        <div><h2 class="ds-card-title">{{ usuario.usuario }}</h2><p class="atividade-observacao">Detalhes das atividades e dados do usuário</p></div>
        <button type="button" class="ds-btn ds-btn--no-icon" (click)="fecharDetalhes()">Fechar detalhes</button>
      </div>
      <dl class="detalhes-resumo">
        <div><dt>Status</dt><dd>{{ usuario.online ? 'Online' : 'Inativo' }}</dd></div>
        <div><dt>Sessões abertas</dt><dd>{{ usuario.sessoesAbertas }}</dd></div>
        <div><dt>Login da sessão mais antiga</dt><dd>{{ formatarDataHora(usuario.loginEm) }}</dd></div>
        <div><dt>Última atividade</dt><dd>{{ formatarDataHora(usuario.ultimoAcessoEm) }}</dd></div>
      </dl>
      <div class="sessao-acoes">
        <button type="button" class="ds-btn ds-btn--no-icon" disabled aria-describedby="logout-pendente">Deslogar usuário</button>
        <p id="logout-pendente" class="atividade-observacao">Encerramento de sessões pendente de integração com o serviço nativo.</p>
      </div>
      <h3>Alterar dados do usuário</h3>
      <p class="atividade-observacao" id="dados-pendentes">Campos preparados para integração futura. Os dados atuais não são consultados e nenhuma alteração será salva.</p>
      <div class="dados-grid" aria-describedby="dados-pendentes">
        <label>Nome<input class="ds-input" type="text" [(ngModel)]="dados.nome" autocomplete="off" placeholder="Nome completo"></label>
        <label>E-mail<input class="ds-input" type="email" [(ngModel)]="dados.email" autocomplete="off" placeholder="usuario@empresa.com"></label>
        <label>Nova senha<input class="ds-input" type="password" [(ngModel)]="dados.senha" autocomplete="new-password" placeholder="Nova senha"></label>
        <label>Confirmar nova senha<input class="ds-input" type="password" [(ngModel)]="dados.confirmarSenha" autocomplete="new-password" placeholder="Repita a nova senha"></label>
      </div>
      <p *ngIf="dados.confirmarSenha && dados.senha !== dados.confirmarSenha" class="ds-alert ds-alert--danger">As senhas não coincidem.</p>
      <button type="button" class="ds-btn ds-btn--no-icon" disabled aria-describedby="dados-pendentes">Salvar alterações</button>
    </section>
    <section class="ds-card log-card" aria-label="Log de ações">
      <div class="ds-card-header">
        <div><h2 class="ds-card-title">Log de ações{{ selecionado ? ' — ' + selecionado.usuario : '' }}</h2>
        <p class="atividade-observacao">{{ selecionado ? 'Histórico do usuário selecionado' : 'Histórico dos usuários da busca' }}</p></div>
        <button *ngIf="selecionado" type="button" class="ds-btn ds-btn--no-icon" (click)="fecharDetalhes()">Ver todos os usuários</button>
      </div>
      <div class="ds-table-container">
        <table class="ds-table ds-table--compact">
          <thead><tr><th>Data e hora</th><th>Usuário</th><th>Ação registrada</th><th>Resultado</th></tr></thead>
          <tbody>
            <tr *ngFor="let acao of acoesPagina">
              <td>{{ formatarDataHora(acao.ocorridoEm) }}</td><td>{{ acao.usuario }}</td><td class="acao-descricao">{{ descreverAcao(acao.acao) }}</td>
              <td><span class="ds-badge" [class.ds-badge--success]="acao.status < 400" [class.ds-badge--pending]="acao.status >= 400">{{ acao.status >= 400 ? 'Falha HTTP' : 'Respondido' }} ({{ acao.status }})</span></td>
            </tr>
            <tr *ngIf="!acoesPagina.length"><td colspan="4" class="ds-table-empty">Nenhuma ação registrada para esta seleção.</td></tr>
          </tbody>
        </table>
      </div>
      <nav class="paginacao" aria-label="Paginação do log de ações">
        <span>{{ acoesFiltradas.length }} ação(ões) · 20 por página</span>
        <button type="button" class="ds-btn ds-btn--no-icon" (click)="paginaLog = paginaLog - 1" [disabled]="paginaLog <= 1">Anterior</button>
        <span aria-live="polite">Página {{ paginaLog }} de {{ totalPaginasLog }}</span>
        <button type="button" class="ds-btn ds-btn--no-icon" (click)="paginaLog = paginaLog + 1" [disabled]="paginaLog >= totalPaginasLog">Próxima</button>
      </nav>
    </section>
  </main>
</div>
